import script from "./UserNotes.vue?vue&type=script&setup=true&lang=js"
export * from "./UserNotes.vue?vue&type=script&setup=true&lang=js"

import "./UserNotes.vue?vue&type=style&index=0&id=4c111440&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c111440"]])

export default __exports__